const prefix = 'lumahealth/ReferralsPage';

export const INITIAL_PAGE = 1;

export const ITEMS_PER_PAGE = 20;

export const GET_EXISTING_REFERRALS = `${prefix}/GET_EXISTING_REFERRALS`;
export const GET_EXISTING_REFERRALS_ERROR = `${prefix}/GET_EXISTING_REFERRALS_ERROR`;
export const GET_EXISTING_REFERRALS_SUCCESS = `${prefix}/GET_EXISTING_REFERRALS_SUCCESS`;

export const LOAD_REFERRALS = `${prefix}/LOAD_REFERRALS`;
export const LOAD_REFERRALS_ERROR = `${prefix}/LOAD_REFERRALS_ERROR`;
export const LOAD_REFERRALS_SUCCESS = `${prefix}/LOAD_REFERRALS_SUCCESS`;

export const LS_REFERRALS_LIST_VIEW = 'lh:referrals_list_view';
export const LS_REFERRALS_TYPE = 'lh:referrals_type';

export const SAVE_REFERRALS_STATUS = `${prefix}/SAVE_REFERRALS_STATUS`;
export const SAVE_REFERRALS_STATUS_ERROR = `${prefix}/SAVE_REFERRALS_STATUS_ERROR`;
export const SAVE_REFERRALS_STATUS_SUCCESS = `${prefix}/SAVE_REFERRALS_STATUS_SUCCESS`;

export const ROUTES = {
  NEW_INBOUND: '/inbound-referrals/add',
  INBOUNDS: '/inbound-referrals',
  OUTBOUNDS: '/outbound-referrals',
  NEW_OUTBOUND: '/outbound-referrals/add',
  UPLOAD_INBOUND: '/inbound-referrals/upload',
};

export const VIEW_RELAXED = 'relaxed';
export const VIEW_COMPACT = 'compact';

export const REFERRAL_INBOUND = 'inbound';
export const REFERRAL_OUTBOUND = 'outbound';
